var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"pa-7",attrs:{"width":_vm.width}},[_c('v-card-title',[_c('h4',[_vm._v(_vm._s(_vm.title))])]),_c('v-card-text',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }